export const formatCustomerProfileType = (type: string): string => {
  return type.replace(/([A-Z])/g, ' $1').trim()
}
